import React, { useState, useEffect } from 'react';

const ManageCategories = () => {
  const [categories, setCategories] = useState([]); // List of categories
  const [newCategory, setNewCategory] = useState(''); // Input for a new category
  const [error, setError] = useState(''); // Error message
  const [success, setSuccess] = useState(''); // Success message

  // Fetch categories on component mount
  useEffect(() => {
    fetch('https://schoolofservice.co.za/backend/get-categories.php')
      .then((response) => response.json())
      .then((data) => {
        console.log('Fetched categories:', data);
        if (data.status === 'success' && Array.isArray(data.categories)) {
          setCategories(data.categories); // Populate categories if response is valid
        } else {
          setCategories([]); // Set to empty array if invalid response
        }
      })
      .catch((error) => console.error('Error fetching categories:', error));
  }, []);

  // Save a new category
  const saveCategory = () => {
    setError('');
    setSuccess('');

    if (!newCategory.trim()) {
      setError('Category name is required');
      return;
    }

    if (newCategory.length < 3) {
      setError('Category name must be at least 3 characters long');
      return;
    }

    const formData = new FormData();
    formData.append('categoryName', newCategory);

    fetch('https://schoolofservice.co.za/backend/save-category.php', {
      method: 'POST',
      body: formData,
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.status === 'success') {
          setSuccess(data.message); // Display success message
          setNewCategory(''); // Clear the input field
          setCategories((prev) => [...prev, { categoryName: newCategory }]); // Add new category to the list
        } else {
          setError(data.message); // Display error message
        }
      })
      .catch((error) => console.error('Error saving category:', error));
  };

  return (
    <div>
      <h2>Manage Categories</h2>
      {/* Display error or success messages */}
      {error && <div className="alert alert-danger">{error}</div>}
      {success && <div className="alert alert-success">{success}</div>}
      <div className="mb-3">
        <input
          type="text"
          className="form-control"
          placeholder="Enter category name"
          value={newCategory}
          onChange={(e) => setNewCategory(e.target.value)} // Update newCategory state
        />
        <button className="btn btn-primary mt-2" onClick={saveCategory}>
          Save Category
        </button>
      </div>
      <h4>Existing Categories</h4>
      {/* Render categories or display fallback message */}
      <ul className="list-group">
        {Array.isArray(categories) && categories.length > 0 ? (
          categories.map((category, index) => (
            <li key={index} className="list-group-item">
              {category.categoryName}
            </li>
          ))
        ) : (
          <li className="list-group-item">No categories available</li>
        )}
      </ul>
    </div>
  );
};

export default ManageCategories;
